import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Title from '../../../components/Headers/Title';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { LicenseProps } from '../../../types/IdProps';
import DataService from "../../../services/data.service";
import { useNotifications } from '../../../contexts/notificationContext';
import AddCategoryPopup from '../Popups/License_popup_AddProductCategory';

const License_tab_ProductCategories: React.FC<LicenseProps> = ({ licenseId }) => {
    const [includedData, setIncludedData] = useState<any[]>();
    const [excludedData, setExcludedData] = useState<any[]>();
    const [included, setIncluded] = useState<boolean>(false)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [licenseId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/LicenseProductCategories/ByLicenseIncluded/' + licenseId)
            .then(response => {
                setIncludedData(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/LicenseProductCategories/ByLicenseExcluded/' + licenseId)
            .then(response => {
                setExcludedData(response);
            })
            .catch(e => { handleException(e); });

    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/LicenseProductCategories/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const includedColInfos: IColInfo[] = [
        { key: true, dataProp: 'productCategoryId', visible: false },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'Category', dataProp: 'productCategoryNameTree', sort: 'asc' },
    ];

    const excludedColInfos: IColInfo[] = [
        { key: true, dataProp: 'productCategoryId', visible: false },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'Category', dataProp: 'productCategoryNameTree', sort: 'asc' },
    ];


    if (isAuthorizedFor(ApplicationFunctions.UpdateLicense)) {
        includedColInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncluded(true); setShowPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });

        excludedColInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncluded(false); setShowPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <Container fluid>
            <Row>
                <Col md='6'>
                    <Title size={4} text='Included' />
                    <DataTable
                        name='dtLicenseIncludedProductCategories'
                        colInfos={includedColInfos}
                        tableData={includedData}
                        navigateTitle={'Category'}
                        navigateUrl={'/plm/ItemSetup/ProductCategory/'}
                    />
                </Col>
                <Col md='6'>
                    <Title size={4} text='Excluded' />
                    <DataTable
                        name='dtLicenseExcludedProductCategories'
                        colInfos={excludedColInfos}
                        tableData={excludedData}
                        navigateTitle={'Category'}
                        navigateUrl={'/plm/ItemSetup/ProductCategory/'}
                    />
                </Col>
            </Row>
            {showPopup && <AddCategoryPopup licenseId={licenseId} included={included} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </Container>

    );
}
export default License_tab_ProductCategories;